import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import Transition from './Dialogs/Transition';

const styles = () => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	sectionHeader : {
		textTransform : 'uppercase',
		fontSize : 14,
		color : '#777',
		fontWeight : 900,
		letterSpacing : 2,
		marginTop : 30,
		marginBottom : 10,
	},
	testBody : {
		border : '1px solid #ddd',
		padding : 10,
	},
	bodyPre : {
		whiteSpace: 'pre-wrap',
	},
	dialogPaper : {
		maxWidth : 1000,
		overflow: 'scroll',
	},
	row : {
		cursor : 'pointer',
	},
	button: {
		verticalAlign : 'middle',
		padding : '8px 10px',
	}
});

class TestNotificationJobDialog extends Component {

	constructor (props) {
		super(props);
		this.handleClose = this.handleClose.bind(this);
	}

	handleClose() {
		this.props.onClose();
	}

	render() {
		const { classes, jobResult } = this.props;
		if (!jobResult) { return null; }

		/** @namespace jobResult.htmlBody **/
		/** @namespace jobResult.textBody **/
		return (
			<Dialog
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper : classes.dialogPaper
				}}
			>
				<div style={{padding:'20px 20px'}}>
					<DialogTitle>
						Notification Job Results
					</DialogTitle>
					<DialogContent>
						<div className={classes.sectionHeader}>
							Email Subject
						</div>
						<div>
							{jobResult.subject}
						</div>

						<div className={classes.sectionHeader}>
							HTML Email Body
						</div>
						<div className={classes.testBody}>
							<div dangerouslySetInnerHTML={{__html : jobResult.htmlBody}} />
						</div>

						<div className={classes.sectionHeader}>
							Text Email Body
						</div>
						<div className={classes.testBody}>
							<pre className={classes.bodyPre}>
								{jobResult.textBody}
							</pre>
						</div>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>
							Close
						</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

TestNotificationJobDialog.propTypes = {
	classes: PropTypes.object.isRequired,
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	jobResult : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
])(TestNotificationJobDialog);